import { buttonActionFunc } from './common/_buttonAction';
import { initSwiper } from './common/_swiper';
import { headerFunc } from './common/_header';
import { headerMenuFunc } from './common/_headerMenu';
import { footerFunc } from './common/_footer';
import { commonFunc } from './common/_common';
import { homeFunc } from './pages/_home';
import { observeFlowNav } from './common/_pageLinkAnimation';

$(window).on('load', function () {
  commonFunc();
  headerFunc();
  headerMenuFunc();
  footerFunc();
  buttonActionFunc();
  initSwiper();
  if (document.querySelector('.js-top')) {
    homeFunc();
  }
  if (window.innerWidth > 768) {
    observeFlowNav();
  }
});
